'use strict'

angular.module('app').directive('validateMonth', function() {
  var MONTH_VALIDATE = /^(0[1-9]|1[012])$/i;

  return {
    require: 'ngModel',
    restrict: '',
    link: function(scope, elm, attrs, ctrl) {
        ctrl.$validators.month = function(modelValue) {
          return ctrl.$isEmpty(modelValue) || MONTH_VALIDATE.test(modelValue);
        }
    }
  };
});